export default __webpack_public_path__ + "static/media/w2.513cb696.png";